import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';
import * as defaultVal from '../../../constants/common/ConstDefaultValue';

const allWeekdays = ['日', '月', '火', '水', '木', '金', '土'];
const weekdays = allWeekdays.slice(defaultVal.WEEK_START_DAY_FLG).concat(allWeekdays.slice(0, defaultVal.WEEK_START_DAY_FLG));

class CalendarDayNew extends React.Component {
  constructor(props) {
    super(props);

    this.handleDateClick = this.handleDateClick.bind(this);
    this.renderDays = this.renderDays.bind(this);
  }

  componentDidMount() {
    // カレンダーコントロール日付ボタンクリック
    const controlDateButton = document.getElementById('header-date-button');
    if (controlDateButton) {
      controlDateButton.addEventListener('click', this.handleHeaderDateClick);
    }
  }

  componentWillUnmount() {
    // カレンダーコントロール日付ボタンクリック
    const controlDateButton = document.getElementById('header-date-button');
    if (controlDateButton) {
      controlDateButton.removeEventListener('click', this.handleHeaderDateClick);
    }
  }

  /**
   * カレンダーUIの日付選択イベントハンドラー
   *
   * @param {*} selectedDate date形式  ※ex) mon sep 23 2024 00:00:00 GMT+0900
   */
  handleDateClick(e, selectedDate) {
    if (this.props.data.isNohinCalendar) {
      // 納品時期カレンダーの場合
      let formattedDate = commonLogic.toLocaleString(selectedDate);
      if (this.props.data.isFromDatePicker) {
        // 納品開始日を選択した場合
        if (this.props.data.nohinkaishibiTo != '') {
          // 補正処理
          let d = new Date(this.props.data.nohinkaishibiTo);
          if (selectedDate > d) {
            // 納品開始日が納品終了日を超えて設定した場合は納品終了日を納品開始日と同じ値を設定する
            formattedDate = commonLogic.toLocaleString(selectedDate).replaceAll('/', '-');
            this.props.data.nohinkaishibiTo = formattedDate;
          }
        }
        if (this.props.isExec) {
          // 即時反映の場合は画面リロードする
          this.props.comactions.changeKaishibiFrom(formattedDate.replaceAll('/', '-'));
        } else {
          // 画面リロードしない場合はカレンダーを閉じる
          this.props.data.nohinkaishibiFrom = formattedDate.replaceAll('/', '-');
          this.props.handleCancel(e);
        }
        // this.props.comactions.changeKaishibiFrom(formattedDate.replaceAll('/', '-'));
      } else {
        // 納品終了日を選択した場合
        if (this.props.data.nohinkaishibiFrom != '') {
          // 補正処理
          let d = new Date(this.props.data.nohinkaishibiFrom);
          if (selectedDate < d) {
            // 納品終了日が納品開始日よりも未満に設定した場合は納品終了日を納品開始日と同じ値を設定する
            formattedDate = commonLogic.toLocaleString(selectedDate).replaceAll('/', '-');
            this.props.data.nohinkaishibiFrom = formattedDate;
          }
        }
        if (this.props.isExec) {
          // 即時反映の場合は画面リロードする
          this.props.comactions.changeKaishibiTo(formattedDate.replaceAll('/', '-'));
        } else {
          // 画面リロードしない場合はカレンダーを閉じる
          this.props.data.nohinkaishibiTo = formattedDate.replaceAll('/', '-');
          this.props.handleCancel(e);
        }
        // this.props.comactions.changeKaishibiTo(formattedDate.replaceAll('/', '-'));
      }
    } else {
      // 期間カレンダーの場合
      let formatType;
      switch (this.props.data.kikanUnit) {
        case 'days':
          formatType = 3;
          break;
        case 'weeks':
          formatType = 2;
          break;
        case 'months':
          formatType = 1;
          break;
        case 'years':
          formatType = 0;
          break;
        default:
          break;
      }
      const targetTerm = commonLogic.formatDate(commonLogic.toTermFormatString(selectedDate), formatType);
      const termFromToMap = commonLogic.formatTermStartEndById(targetTerm, this.props.data.kikanUnit);
      const termStart = termFromToMap.fromDate;
      const termEnd = termFromToMap.toDate;

      this.props.data.term = targetTerm;
      this.props.data.termStart = termStart;
      this.props.data.termEnd = termEnd;
      this.props.data.displayDate = selectedDate;
      if (this.props.isExec) {
        // 即時反映の場合は画面リロードする
        this.props.comactions.changeKikanTerm(targetTerm, termStart, termEnd, selectedDate);
      } else {
        // 画面リロードしない場合はカレンダーを閉じる
        this.props.handleCancel(e);
      }
    }
  }

  isSameDate(date1, date2) {
    if (!date1 || !date2) {
      return false;
    }
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  renderDays() {
    const currentDate = this.props.data.displayDate;
    if (currentDate) {
      const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      const days = [];

      // 前月の最後の日を取得
      const prevMonthEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      const prevMonthEndDay = prevMonthEndDate.getDate();

      // 当月の初日の曜日を取得
      const startDayWeekDay = startDate.getDay();

      // 前月の日付を追加
      if (startDayWeekDay !== defaultVal.WEEK_START_DAY_FLG) {
        const daysToAdd = (startDayWeekDay - defaultVal.WEEK_START_DAY_FLG + 7) % 7;
        for (let i = prevMonthEndDay - daysToAdd + 1; i <= prevMonthEndDay; i++) {
          days.push({
            date: new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, i),
            isCurrentMonth: false
          });
        }
      }

      // 現在の月の日付を追加
      for (let i = 1; i <= endDate.getDate(); i++) {
        days.push({
          date: new Date(currentDate.getFullYear(), currentDate.getMonth(), i),
          isCurrentMonth: true
        });
      }

      // 次月の日付を追加
      const endDayWeekDay = endDate.getDay();
      if (endDayWeekDay !== weekdays[weekdays.length - 1]) {
        const daysToAdd = (weekdays.length - 1 - endDayWeekDay + 7) % 7 + 1;
        for (let i = 1; i <= daysToAdd; i++) {
          days.push({
            date: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i),
            isCurrentMonth: false
          });
        }
      }

      // 選択期間の種類が週間かどうか
      const isWeekSelected = this.props.data.kikanUnit === 'weeks';
      // 選択中の期間値かどうか

      const kikanUnit = this.props.data.kikanUnit;
      const targetTermDate = new Date(this.props.data.term);
      targetTermDate.setHours(0, 0, 0, 0);
      let termFromDate;
      let termToDate;
      if (this.props.data.kikanUnit == 'weeks') {
        let termFromTo = commonLogic.formatTermStartEndById(this.props.data.term, 'weeks');
        termFromDate = new Date(termFromTo.fromDate);
        termToDate = new Date(termFromTo.toDate);
      }

      const calendarElements = days.map(({ date, isCurrentMonth }) => {
        const dayOfWeek = date.getDay();
        let className = '';

        const isNohinCalendar = this.props.data.isNohinCalendar;
        const nohinData = this.props.data.nohinTermData;
        const termData = this.props.data.termData;
        let isSelectedEnabledTerm = false;

        if (isNohinCalendar) {
          // 納品時期カレンダーの場合
          const recentNohinDate =  new Date(nohinData.data[0].model.nohinkaishibi);

          // 期間単位がdays(1日)で、選択中の場合の条件
          const target = this.props.data.isFromDatePicker ? this.props.data.nohinkaishibiFrom : this.props.data.nohinkaishibiTo;
          const targetDate = target ? new Date(target) : '';
          const isDaySelected = this.isSameDate(date, targetDate);
          const isRangeDate = recentNohinDate >= date;

          if (!isRangeDate || !isCurrentMonth) {
            className = 'no_data';
          } else if (isDaySelected) {
            className = 'selected';
          } else if (dayOfWeek === 6) {
            className = 'sat';
          } else if (dayOfWeek === 0) {
            className = 'cal_right sun';
          }
        } else {
          // 期間カレンダーの場合
          let matchTermData;
          if (kikanUnit == 'days') {
            // 日間の場合
            matchTermData = termData.filter((item) => {
              // termDataのN要素のfrom_date, to_dateの範囲内にあるかチェック
              let termStartDate = new Date(item.from_date);
              termStartDate.setHours(0, 0, 0, 0);
              let termEndDate = new Date(item.to_date);
              termEndDate.setHours(0, 0, 0, 0);
              return date >= termStartDate && date <= termEndDate;
            });
          } else {
            // 週間の場合
            matchTermData = termData.filter((item) => {
              // termDataのN要素のID(YYYY-W99)の開始日終了を取得する
              let weekFromToList = commonLogic.getWeekStartAndEnd(item.id, 7, 3);
              let termStartDate = new Date(weekFromToList[0]);
              termStartDate.setHours(0, 0, 0, 0);
              let termEndDate = new Date(weekFromToList[weekFromToList.length - 1]);
              termEndDate.setHours(0, 0, 0, 0);
              return date >= termStartDate && date <= termEndDate;
            });
          }

          if (matchTermData != undefined && matchTermData != null && matchTermData.length != 0) {
            isSelectedEnabledTerm = true;
          }

          if (!isSelectedEnabledTerm) {
            // 選択不可能な日付の場合は非活性にする
            className = 'no_data';
          } else {
            if (isWeekSelected) {
              if (matchTermData[0].id == this.props.data.term) {
                // 選択中期間の場合のスタイル設定(週間)
                className += ' selected-week';
                if (date.getFullYear() == termFromDate.getFullYear() && date.getMonth() == termFromDate.getMonth() && date.getDay() == termFromDate.getDay()) {
                  className += ' start';
                }
                if (date.getFullYear() == termToDate.getFullYear() && date.getMonth() == termToDate.getMonth() && date.getDay() == termToDate.getDay()) {
                  className += ' end';
                }
              }
              // 選択週であるがtermデータに含まれていない場合は文字色を非活性状態にする
              const weekFromDate = new Date(matchTermData[0].from_date);
              weekFromDate.setHours(0, 0, 0, 0);
              const weekToDate = new Date(matchTermData[0].to_date);
              weekToDate.setHours(0, 0, 0, 0);
              const offsetDay = (weekToDate - weekFromDate) / (1000 * 60 * 60 * 24);
              // termデータの該当週のfrom,toから日付範囲の配列を作成
              const matchTermFromToList = Array.from({ length: offsetDay + 1 },
                (_, i) => {
                  const newDate = new Date(weekFromDate); // 毎回新しい Date オブジェクトを作成
                  newDate.setDate(newDate.getDate() + i); // インデックスで日を加算
                  return commonLogic.toLocaleString(newDate).replaceAll('/', '-');
                }
              );
              if (matchTermFromToList.indexOf(commonLogic.toLocaleString(date).replaceAll('/', '-')) == -1) {
                // 選択中の週において、termに存在しない日付の場合
                className += ' no_data_color';
              }
            } else {
              if (!isCurrentMonth) {
                className = 'no_data';
              }

              let isCurrentDate = (
                targetTermDate.getFullYear() == date.getFullYear() &&
                targetTermDate.getMonth() == date.getMonth() &&
                targetTermDate.getDate() == date.getDate()
              );
              if (isCurrentDate) {
                // 選択中期間の場合のスタイル設定(日間)
                className += ' selected';
              }
            }
          }

          if (dayOfWeek === 6) {
            // 土曜日の場合
            className += ' sat';
          }
          if (dayOfWeek === 0) {
            // 日曜日の場合
            className += ' cal_right sun';
          }
        }

        return (
          <div key={date} className={className} onClick={e => this.handleDateClick(e, date)}>
            {date.getDate()}
          </div>
        );
      });

      if (!isWeekSelected || this.props.data.isNohinCalendar) return calendarElements;

      const Nodes = [];
      const currentMonth = currentDate.getMonth() + 1;
      for (let i = 0; i < calendarElements.length; i += 7) {
        const elementList = calendarElements.slice(i, i + 7);

        const currentMonthList = elementList.filter((item) => {
          if (new Date(item.key).getMonth() + 1 == currentMonth) {
            return true;
          }
          return false;
        });

        if (currentMonthList.length != 0) {
          Nodes.push(
            <div className="selected-week-rows">{elementList}</div>
          );
        } else {
          // 当該月の日が存在しない週の場合は非活性にする
          elementList.forEach((item) => {
            item.props.className = 'no_data_color';
          });

          Nodes.push(
            <div className="selected-week-rows-empty">{elementList}</div>
          );
        }
      }
      return Nodes;
    }
  }

  render() {
    const isWeekSelected = this.props.data.kikanUnit === 'weeks';

    const targetClassName = (isWeekSelected && !this.props.data.isNohinCalendar) ? 'date-picker-weekdays' : 'date-picker-days';
    return (
      <div>
        <div className="date-picker-dow-header">
          {weekdays.map((day) => {
            let className = '';
            if (day === '土') {
              className = 'sat';
            } else if (day === '日') {
              className = 'cal_right sun';
            }
            return <div key={day} className={className}>{day}</div>;
          })}
        </div>
        <div id="calendar-days" className={targetClassName}>
          {this.renderDays()}
        </div>
      </div>
    );
  }
}

CalendarDayNew.propTypes = {
  data: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  isExec: PropTypes.any.isRequired
};

export default CalendarDayNew;
